<template>
  <div>
       <div id="one_view_form" v-if="person_details!=null">
             <!-- <view-application-form :person_details=person_details></view-application-form> -->
             <AFUWWS v-if="tenant == 'uwws'" :person_details=person_details></AFUWWS>
             <AFWWS v-else-if="tenant == 'wws'" :person_details=person_details></AFWWS>
             <AFVVP v-else-if="tenant == 'vvp'" :person_details=person_details></AFVVP>
             <AFZEAL v-else-if="tenant == 'zeal'" :person_details=person_details></AFZEAL>
             <AFEPS v-else-if="tenant == 'eps'" :person_details=person_details></AFEPS>
             <AFSBPPS v-else-if="tenant == 'sbpps'" :person_details=person_details></AFSBPPS>
             <AFSANJIVANI v-else-if="tenant == 'sanjivani'" :person_details=person_details></AFSANJIVANI>
             <AFTMV v-else-if="tenant == 'tmvidyalaya'" :person_details=person_details></AFTMV>
             <VDAF v-else :person_details=person_details></VDAF>
        </div>
  </div>
  
</template>

<script>
import axios from "axios";
 import VDAF from "./ViewDownloadApplicationForm.vue";
import AFUWWS from "./AdmissionFormView/AddmissionFormUwws.vue";
import AFVVP from "./AdmissionFormView/AddmissionFormVvp.vue";
import AFWWS from "./AdmissionFormView/AddmissionFormWws.vue";
import AFZEAL from "./AdmissionFormView/AddmissionFormZeal.vue";
import AFEPS from "./AdmissionFormView/AdmissionFormEPS.vue";
import AFSBPPS from "./AdmissionFormView/AdmissionFormSbpps.vue";
import AFSANJIVANI from "./AdmissionFormView/AdmissionFormSanjivani.vue";
import AFTMV from "./AdmissionFormView/AdmissionFormTMV.vue";
export default {
     components: {
      VDAF,
            AFUWWS,
            AFVVP,
            AFWWS,
            AFZEAL,
            AFEPS,
            AFSBPPS,
            AFSANJIVANI,
            AFTMV,
            },
  data() {
    return {
      form_progress: 0,
      admission_form_no: null,
      person_details:null,
      tenant:null,
      ay:null
    };
  },
   created() {
    this.tenant = localStorage.getItem("EPS-tenant");
  },
  watch: {
    "$store.state.form_progress": function () {
      this.form_progress = this.$store.getters.form_progress;
    },
  },
  methods: {
    getform() {
      // console.log("1111"+this.ay)
      // console.log("this.admission_form_no"+this.admission_form_no)
      const data = {
        ay: this.ay,
        form_id: this.admission_form_no,
      };
      localStorage.setItem("admission-ay", this.ay);
      axios
        .post("/Admission/get_application_form", data)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.status.code == "SUCCESS") {
            this.person_details = res.data.person_details;
            this.$store.commit("setform_progress", res.data.form_progress);
          } else {
            console.log("Nah...");
            this.person_details = null;
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    this.admission_form_no = localStorage.getItem("admission_form_no"); // localStorage.setItem("application_form_no",this.admission_form_no)
    this.ay = localStorage.getItem("admission-ay"); // localStorage.setItem("application_form_no",this.admission_form_no)
    localStorage.setItem("setform_id", this.admission_form_no);
    localStorage.setItem("setay", this.ay);
    this.getform();
  },
};
</script>

<style>
</style>